/**
 * Append a `/:op=<slug>` segment to a URL so the call is distinguishable
 * in Chrome DevTools' Network "Name" column. The matching edge functions
 * strip this segment before routing/forwarding upstream, so it's purely
 * an observability aid and never reaches third-party services.
 */
const OP_SLUG_RE = /^[a-z0-9-]+$/;

export function appendOp(url: string, op?: string): string {
  if (!op) return url;
  if (!OP_SLUG_RE.test(op)) {
    throw new Error(`invalid op slug "${op}" (expected [a-z0-9-]+)`);
  }
  const qIdx = url.indexOf("?");
  const path = qIdx === -1 ? url : url.slice(0, qIdx);
  const query = qIdx === -1 ? "" : url.slice(qIdx);
  return `${path}/:op=${op}${query}`;
}